import { render, staticRenderFns } from "./AddLotinPoList.vue?vue&type=template&id=3d96c029&scoped=true"
import script from "./AddLotinPoList.vue?vue&type=script&lang=js"
export * from "./AddLotinPoList.vue?vue&type=script&lang=js"
import style0 from "./AddLotinPoList.vue?vue&type=style&index=0&id=3d96c029&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d96c029",
  null
  
)

export default component.exports